import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { DocumentRegistryNewCrumbs } from 'civil-status/constants/document-registry-breadcrumb';
import FormDocumentRegistry, {
  DocumentRegistryForm,
} from 'civil-status/components/document-registry/form';
import { useNavigate } from 'react-router-dom';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const DocumentRegistryNewPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const insertRegistry = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/registro-atto/crea-registro-atto`,
    {
      options: {
        method: 'POST',
      },
    }
  );

  const handleSubmit = useCallback(
    (values: DocumentRegistryForm) => {
      (
        insertRegistry({
          data: {
            registro: values.description,
            key: {
              codiceRegistro: values.number,
            },
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/registri');
      });
    },
    [insertRegistry, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={DocumentRegistryNewCrumbs} />
      <FormDocumentRegistry
        title={'Nuovo Numero Registro'}
        onOk={handleSubmit}
        onCancel={() => {
          navigate('/stato-civile/registri');
        }}
      ></FormDocumentRegistry>
    </Fragment>
  );
};

DocumentRegistryNewPage.displayName = 'Document Registry New page component';

export default DocumentRegistryNewPage;
